module.exports = __webpack_public_path__ + "img/coop-class.938af650.jpeg";